/** 中国大陆手机号：去前缀后须为 1[3-9] 开头的 11 位。 */
const CHINA_MOBILE_BODY = /^1[3-9]\d{9}$/;

/** 可识别并剥离的国家码前缀（长匹配优先）。 */
const CHINA_MOBILE_PREFIXES = ["(+86)", "（+86）", "+86", "0086", "086", "86"] as const;

/**
 * 将用户输入规范为 11 位中国大陆手机号；无法识别则返回 null。
 */
export function normalizeChinaMobile(input: string): string | null {
  const s = (input || "").trim().replace(/[\s\-]/g, "");
  if (!s) return null;

  const candidates = [s];
  for (const prefix of CHINA_MOBILE_PREFIXES) {
    if (s.startsWith(prefix)) {
      candidates.push(s.slice(prefix.length));
    }
  }

  for (const candidate of candidates) {
    if (CHINA_MOBILE_BODY.test(candidate)) {
      return candidate;
    }
  }
  return null;
}
